import { type TMode, type TModePath } from '../store';

import * as styles from './commands.css';

/** Globally-registered modes, keyed by path. `/set-theme` is the theme-picker
 * sub-menu; it shows only its own actions (hides the root commands while you pick). */
export const SPOTLIGHT_MODES: Record<TModePath, TMode> = {
  '/set-theme': {
    prefixRender: () => <span className={styles.chip}>Theme</span>,
    exclusive: true,
  },
};
